var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11093",
    "data-name": "Group 11093",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.038,
    height: 24.038,
    viewBox: "0 0 24.038 24.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3152",
    "data-name": "Rectangle 3152",
    width: 24.038,
    height: 24.038,
    fill: "#00b7cc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11092",
    "data-name": "Group 11092",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28990",
    "data-name": "Path 28990",
    d: "M23.153,0H13.269a2.65,2.65,0,0,0-1.876.779L.777,11.395a2.651,2.651,0,0,0,0,3.751L8.892,23.26a2.651,2.651,0,0,0,3.751,0L23.259,12.644a2.65,2.65,0,0,0,.779-1.876V.885A.885.885,0,0,0,23.153,0m-.885,10.768a.883.883,0,0,1-.258.626L11.394,22.011a.883.883,0,0,1-1.257,0L2.027,13.9a.883.883,0,0,1,0-1.257L12.643,2.028a.883.883,0,0,1,.626-.258h9Z",
    transform: "translate(0 0)",
    fill: "#00b7cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28991",
    "data-name": "Path 28991",
    d: "M16.153,7.687A2.654,2.654,0,1,0,13.5,5.033a2.655,2.655,0,0,0,2.654,2.654m0-3.539a.885.885,0,1,1-.885.885.885.885,0,0,1,.885-.885",
    transform: "translate(2.424 0.427)",
    fill: "#00b7cc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon10);
export default __webpack_public_path__ + "static/media/icon10.8deb3e50af2c91232d1ede1810578657.svg";
export { ForwardRef as ReactComponent };